import { inputResult } from "../Submit/SaveAnswer";


export function transformScToSelf(input:JQuery, results:inputResult, points:number, possible:number){
    
    const options = input.find(".form-check");
    
    options.each((ind, obj) => {
        $(obj).find("input").prop('disabled', true);
    })

}